enum FileType {
  Unknown = 'unknown',
  Graphic = 'graphic',
  Image = 'image',
  Video = 'video',
  Audio = 'audio',
  Settings = 'settings',
  mp4 = 'video/mp4',
  webm = 'video/webm',
  gif = 'image/gif',
  jpg = 'image/jpeg',
  png = 'image/png',
  json = 'application/json',
  Font = 'font',
  SRT = 'srt'
}

export default FileType;

export const getFileTypeFromExtension = (extension: string): FileType => {
  const ext = extension.toLowerCase();
  switch (ext) {
    case 'jpg':
    case 'jpeg':
      return FileType.jpg;
    case 'png':
      return FileType.png;
    default:
      return FileType.Unknown;
  }
};



// WEBPACK FOOTER //
// ./src/data/FileType.ts